import type { AstroLocale } from '@/schemas/components/shared/i18n';

interface ErrorMessages {
  general: Record<AstroLocale, string>;
  empty: Record<AstroLocale, string>;
  radio: Record<AstroLocale, string>;
  phone: Record<AstroLocale, string>;
  emailValid: Record<AstroLocale, string>;
  emailDomain: Record<AstroLocale, string>;
  field_length: Record<AstroLocale, (charNumber: number) => string>;
  formSubmission: Record<AstroLocale, string>;
}

export const ERROR_MESSAGES: ErrorMessages = {
  general: {
    en: 'There is a problem with the form submission. Please review the form fields below',
    fr: "Il y a un problème avec l'envoi du formulaire. Veuillez vérifier les champs de formulaire ci-dessous",
    de: 'Es gibt ein Problem bei der Einreichung des Formulars. Bitte prüfen Sie die nachfolgenden Formularfelder',
    es: 'Se ha producido un problema con el envío del formulario. Revise los siguientes campos del formulario',
    nl: 'Er is een probleem opgetreden met de indiening van het formulier. Herzie de onderstaande formuliervelden',
    // TODO: Add translation for zh
    zh: 'UNKNOWN_TRANSLATION',
  },
  empty: {
    en: 'Please fill in this field',
    fr: 'Veuillez remplir ce champ',
    de: 'Bitte füllen Sie dieses Feld aus',
    es: 'Debe rellenar este campo',
    nl: 'Vul dit veld in',
    zh: '请填写此字段',
  },
  radio: {
    en: 'Please select one option',
    fr: 'Veuillez sélectionner une option',
    de: 'Bitte wählen Sie eine Option',
    es: 'Por favor selecciona una opcion',
    nl: 'Selecteer een optie',
    // TODO: Add translation for zh
    zh: 'UNKNOWN_TRANSLATION',
  },
  phone: {
    en: 'Invalid number',
    fr: 'Numéro non valide',
    de: 'Ungültige Nummer',
    es: 'Número no válido',
    nl: 'ongeldig getal',
    zh: '✕无效号码',
  },
  emailValid: {
    en: 'Please enter a valid email address',
    fr: 'Veuillez saisir une adresse e-mail valide',
    de: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    es: 'Introduzca una dirección de correo electrónico válida',
    nl: 'Voer een geldig e-mailadres in',
    zh: '请输入有效的电子邮箱',
  },
  emailDomain: {
    en: 'Please use a corporate email address',
    fr: "Veuillez utiliser une adresse e-mail d'entreprise",
    de: 'Bitte verwenden Sie eine Firmen-E-Mail-Adresse',
    es: 'Utilice una dirección de correo electrónico corporativa',
    nl: 'Gebruik een zakelijk e-mailadres',
    zh: '请使用公司电子邮箱',
  },
  field_length: {
    en: (charNumber: number) =>
      `This field cannot be longer than ${charNumber} characters`,
    fr: (charNumber: number) =>
      `Ce champ ne peut pas dépasser ${charNumber} caractères`,
    de: (charNumber: number) =>
      `Dieses Feld darf nicht länger als ${charNumber} Zeichen sein`,
    es: (charNumber: number) =>
      `Este campo no puede tener más de ${charNumber} caracteres`,
    nl: (charNumber: number) =>
      `Dit veld mag niet langer zijn dan ${charNumber} tekens`,
    zh: (charNumber: number) => `该字段长度不能超过${charNumber}个字符`,
  },
  formSubmission: {
    en: 'Submission error. Please review and resubmit.',
    fr: 'Erreur de soumission. Veuillez examiner et soumettre à nouveau.',
    de: 'Übermittlungsfehler. Bitte überprüfen und erneut einreichen.',
    es: 'Error de envío. Por favor revise y vuelva a enviar.',
    nl: 'Fout bij verzending. Controleer het bericht en dien het opnieuw in.',
    zh: '提交表格时出现问题。请检查下方的表格字段',
  },
};
